"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Format = void 0;
const getPhone = (value) => {
    return value.replace(/ |-|(|)/g, '');
};
exports.Format = {
    getPhone
};
//# sourceMappingURL=Format.helper.js.map